module.exports = __webpack_public_path__ + "img/H-B-1-unload-connect-shadow.6a548473.png";